(function () {
  'use strict';

  var removableParameters = [
    'cid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
  ];

  function cleanAddressBar() {
    try {
      var url = new URL(window.location.href);
      var changed = false;

      removableParameters.forEach(function (parameter) {
        if (url.searchParams.has(parameter)) {
          url.searchParams.delete(parameter);
          changed = true;
        }
      });

      if (changed) {
        window.history.replaceState(window.history.state, document.title,
          url.pathname + (url.search ? url.search : '') + url.hash);
      }
    } catch (error) {
      // Browsers sem suporte a URL continuam funcionando normalmente.
    }
  }

  // Dá tempo para as ferramentas de atribuição registrarem os parâmetros e
  // limpa somente o endereço mostrado ao cliente.
  window.addEventListener('load', function () {
    window.setTimeout(cleanAddressBar, 800);
  });
  window.addEventListener('pageshow', function () {
    window.setTimeout(cleanAddressBar, 800);
  });
}());

/* MT Sports — proteção do fluxo de compra para botões especiais (qtd/compre junto).
   Corrige o caminho legado que adicionava o item, mas podia disparar o carrinho
   com uma variante inexistente. O fluxo normal dos demais produtos não é alterado. */
(function () {
  'use strict';

  function specialBuyButton(target) {
    return target && target.closest ? target.closest('.product-form .botaocmprar, .product-form .botaoaddcarrinho-qtd') : null;
  }

  document.addEventListener('click', function (event) {
    var button = specialBuyButton(event.target);
    if (!button) return;

    var form = button.closest('.product-form');
    if (!form) return;

    var variantNode = form.querySelector('.options.active .iddavariante') || form.querySelector('.options .iddavariante');
    if (!variantNode) return;

    var variantId = parseInt(variantNode.getAttribute('val'), 10);
    var quantity = parseInt(variantNode.getAttribute('qtd'), 10) || 1;
    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (button.getAttribute('data-mt-adding') === '1') return;
    button.setAttribute('data-mt-adding', '1');
    button.setAttribute('aria-busy', 'true');

    var items = [{ id: variantId, quantity: quantity }];
    form.querySelectorAll('.buy-together-list input:checked').forEach(function (input) {
      var id = parseInt(input.getAttribute('data-id'), 10);
      if (id) items.push({ id: id, quantity: 1 });
    });

    var cartAddUrl = (window.routes && window.routes.cartAddUrl) ? window.routes.cartAddUrl : '/cart/add';
    fetch(cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_add_failed');
      window.location.assign('/cart');
    }).catch(function () {
      button.removeAttribute('data-mt-adding');
      button.removeAttribute('aria-busy');
    });
  }, true);
}());
